import { Component } from '@angular/core';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss']
})
export class IntroComponent {}



// WEBPACK FOOTER //
// ./src/app/components/intro/intro.component.ts